import DeliveryDetails from '../../../../elements/DeliveryDetails'
import withMapList from '../../../../elements/HOC/withMapList'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import React, { useEffect } from 'react'
import { Checkbox, Col, Form, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { compose } from 'recompose'

function DeliveryRouteNewForm (props) {
  const { line, list, cargo } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const stops = get(cargo, 'stops', [])

  function stopLabel (stop) {
    return `${get(stop, 'location.address.label')}, 
        ${get(stop, 'location.country')}, 
        ${get(stop, 'location.location')}`
  }

  console.log(list)
  const RouteSelect = compose(
    withData({ data: list }),
    withSort,
    withMapList((l) => {
      return {
        ...l,
        display: `Start :${stopLabel(l.start)} - End:${stopLabel(l.end)}`,
      }
    }),
  )(CustomSelect)

  const StopsSelect = compose(
    withData({ data: stops }),
    withSort,
    withMapList((l) => {
      return {
        ...l,
        display: stopLabel(l),
      }
    }),
  )(CustomSelect)

  const isEnd = !getFieldValue('isEnd') || false
  useEffect(() => {
    if (!isEmpty(list) && isEnd) {
      setFieldsValue({ route: list[list.length - 1]._id })
    }
  }, [isEnd])

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item label="is Final Stop" {...defaultFormItemLayout}>
            {getFieldDecorator('isEnd', {
              initialValue: true,
              valuePropName: 'checked',
            })(<Checkbox/>)}
          </Form.Item>
        </Col>
      </Row>
      {/*{!getFieldValue('isEnd') && (*/}
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Select Route'}>
            {getFieldDecorator('route', {
              initialValue: get(line, 'route'),
              rules: rules.select,
            })(
              <RouteSelect
                keyAtr={'_id'}
                valueAtr={'display'}
                // disabled={!getFieldValue('isEnd')}
                placeholder={'Select an Route'}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      {/*)}*/}
      <Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Existing Route" {...defaultFormItemLayout}>
              {getFieldDecorator('isExisting', {
                initialValue: true,
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {getFieldValue('isExisting') ? (
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Stop'}>
                {getFieldDecorator('stop.shearedID', {
                  initialValue: get(line, 'stop.shearedID'),
                  rules: rules.select,
                })(<StopsSelect keyAtr={'shearedID'} valueAtr={'display'} placeholder={'Select an enquiry'}/>)}
              </Form.Item>
            </Col>
          ) : (
            <DeliveryDetails
              doc={{}}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'route',
                prefix: 'location',
                hideTitle: true,
                hideDangerous: true,
              }}
            />
          )}
        </Row>
      </Row>
    </Form>
  )
}

DeliveryRouteNewForm.propTypes = {}
DeliveryRouteNewForm.defaultProps = {}

export default Form.create()(DeliveryRouteNewForm)
